<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="row">
        <div class="col-md-12">
          <div class="top-list-toolbar">
            <div>
              <h4 class="text-primary">Inventory</h4>
              <ol class="breadcrumb breadcrumb-card-header">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0);" @click="backParent">Inventory</a>
                </li>
                <li class="breadcrumb-item active">
                  <span v-if="inventory.id === null">New</span>
                  <span v-else>{{ inventory.inventory_no }}</span>
                </li>
              </ol>
              <!-- <button type="button" @click="backParent" class="btn btn-sm btn-hard-outline-primary pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button> -->
              <button class="btn btn-success btn-sm pull-left dropdown-toggle" type="button" id="printsales" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-show="inventory.id !== null">Action</button>
              <div class="dropdown-menu" aria-labelledby="printsales">
                <a type="button" @click="setCOGS" class="dropdown-item" href="javascript:void(0)" v-show="inventory.id !== null">Set COGS</a>
                <a type="button" @click="setCOGSAll" class="dropdown-item" href="javascript:void(0)" v-show="inventory.id !== null">Set COGS All</a>
                <a type="button" @click="approveInventory" class="dropdown-item" href="javascript:void(0)" v-show="inventory.id !== null">Approve</a>
                <a type="button" @click="setAccountBegin" class="dropdown-item" href="javascript:void(0)" v-show="inventory.id !== null">Set Saldo Persediaan</a>
                <a type="button" @click="setModal" class="dropdown-item" href="javascript:void(0)" v-show="inventory.id !== null">Set Saldo Modal</a>
              </div>
              <button type="button" @click="updateInventory" class="btn btn-sm btn-soft-primary pull-left" v-show="inventory.id !== null"><i class="fa fa-check" aria-hidden="true"></i> Update</button>
              <!-- <button type="button" @click="updateDraftInventory" class="btn btn-sm btn-soft-primary pull-left" v-show="inventory.id !== null"><i class="fa fa-check" aria-hidden="true"></i> Update Draft</button> -->
              <button type="button" @click="saveInventory" class="btn btn-sm btn-soft-primary pull-left" v-show="inventory.id == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
              <button type="button" class="btn btn-sm btn-warning pull-right" data-toggle="modal" data-target="#modalRequestEdit" data-backdrop="static" data-keyboard="false"><i class="fa fa-reply" aria-hidden="true"></i> Request Edit</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="card card-list">
          <div class="card-header">
            <h5 class="text-primary">
              <span v-if="inventory.id !== null">{{ inventory.inventory_no }}</span>
              <span v-else>New</span>
              <button type="button" class="btn btn-sm btn-hard-outline-primary pull-right mb-2" data-toggle="modal" data-target="#modalInventoryDetail" data-backdrop="static" data-keyboard="false" @click="setSetting">Setting</button>
            </h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <dl class="row dl-custom font-12">
                  <dt class="col-md-5">Invoice No.</dt>
                  <dd class="col-md-7">
                    <span v-if="inventory.lock">{{ inventory.ext_no }}</span>
                    <input type="text" class="form-control form-control-lite" v-model="inventory.ext_no" v-else>
                  </dd>

                  <dt class="col-md-5">Date</dt>
                  <dd class="col-md-7">
                    <!-- <input type="text" class="form-control" v-model="inventory.inventory_date"> -->
                    <span v-if="inventory.lock"><b>{{ inventory.inventory_date | dateFormat('DD/MM/YYYY') }}</b></span>
                    <datetime v-else v-model="inventory.inventory_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local"></datetime>
                  </dd>

                  <dt class="col-md-5">Type</dt>
                  <dd class="col-md-7">
                    <select v-model="inventory.type_id" class="form-control">
                      <option v-for="t in inventoryTypeList" :key="t.id" :value="t.id">{{ t.name }}</option>
                    </select>
                  </dd>
                </dl>
              </div>
              <div class="col-md-6">
                <dl class="row dl-custom">
                  <dt class="col-md-5">Company</dt>
                  <dd class="col-md-7">
                    <select class="form-control" v-model="inventory.company_no">
                      <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                    </select>
                  </dd>
                  <dt class="col-md-5">Warehouse</dt>
                  <dd class="col-md-7">
                    <span v-if="inventory.lock">{{ inventory.warehouse }}</span>
                    <select v-else v-model="inventory.warehouse_no" id="warehouse_no" class="form-control form-control-lite" :disabled="inventory.lock">
                      <option value="">---</option>
                      <option v-for="w in warehouseList" :key="w.id" :value="w.warehouse_no"><b>[{{ w.warehouse_no }}]</b> {{ w.name }}</option>
                    </select>
                  </dd>
                  <dt class="col-md-5">Vendor No.</dt>
                  <dd class="col-md-7">
                    <v-select class="vsc-custom" :options="vendorSelect" :reduce="vendor => vendor.meta.code" label="vendor" v-model="inventory.vendor_no" :disabled="inventory.lock"/>
                  </dd>
                  <dt class="col-md-5">Notes:</dt>
                  <dd class="col-md-7">
                    <textarea rows="3" class="form-control" v-model="inventory.notes"></textarea>
                  </dd>
                </dl>
              </div>
            </div>
            <div class="row" v-if="inventory.type_id === 'regular'">
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table table-sm table-item table-striped">
                    <thead>
                      <th>Product</th>
                      <th>Qty</th>
                      <th>UoM</th>
                      <th>Serial Number</th>
                      <th>#</th>
                    </thead>
                    <tbody>
                      <tr v-for="(p, index) in inventory.details" :key="index">
                        <td>
                          <v-select :options="productselect" :reduce="product => product.meta.code" label="product" v-model="p.product_no" @input="setProduct(index)" :disabled="inventory.lock"/>
                        </td>
                        <td><input type="text" v-model="p.qty_done" class="form-control" :disabled="inventory.lock"/></td>
                        <td>
                          <select v-model="p.uom_id" class="form-control" @input="setUom(index, p.uom_id, $event)" :disabled="inventory.lock">
                            <option v-for="u in p.uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                          </select>
                        </td>
                        <td><input type="text" v-model="p.serial_number" class="form-control" :disabled="p.canBarcode === false"/></td>
                        <td>
                          <button type="button" class="btn btn-sm btn-soft-outline-danger" @click="remove(index)" v-if="inventory.lock === false">
                            <i class="fa fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span @click="addLine" class="link-secondary" v-if="inventory.lock === false">Add Line</span>
                        </td>
                        <td><h5>Total: {{ totalDetailCount }}</h5></td>
                        <td>
                          {{ totalDetailQtyDemand }}
                        </td>
                        <td>
                          {{ totalDetailQtyDone }}
                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="row" v-else-if="inventory.type_id ==='begin' ||  inventory.type_id === 'adjust'">
              <div class="col-md-12">
                <div>Total Barang Dagangan: {{ totalBarangDagangan | currency }} ({{ countRowBarangDagangan | currency }})</div>
                <div>Total Bahan Baku: {{ totalBahanBaku | currency }} ({{ countRowBahanBaku | currency }})</div>
                <div>Total Barang Jadi: {{ totalBarangJadi | currency }} ({{ countRowBarangJadi | currency }})</div>
                <div>Total Barang Setengah Jadi: {{ totalBarangSetengahJadi | currency }} ({{ countRowBarangSetengahJadi | currency }})</div>
                <div>Total Raw: {{ totalDetailRaw | currency }}</div>
                <div class="table-responsive">
                <!-- <pre>{{ uomList }}</pre> -->
                  <table class="table table-sm table-item table-striped">
                    <thead>
                      <th>No.</th>
                      <th>Product No.</th>
                      <th>Type</th>
                      <th>Qty</th>
                      <th>UoM</th>
                      <th>Harga</th>
                      <th>Total</th>
                      <th>Serial Number</th>
                      <th>Serial Number 2</th>
                      <th>Vendor</th>
                      <th>#</th>
                    </thead>
                    <tbody>
                      <tr v-for="(p, index) in inventory.details" :key="p.id">
                        <td>{{ index + 1 }}</td>
                        <td>
                          <v-select :options="productselect" :reduce="product => product.meta.code" label="product" v-model="p.product_no" @input="setProduct(index)" :disabled="inventory.lock"/>
                        </td>
                        <td>{{ p.product_type }} ({{ p.product_type_id }})</td>
                        <!-- <td><b>{{ p.product_sku }}</b></td> -->
                        <!-- <td><input type="text" v-model="p.product" class="form-control" disabled="disabled"></td> -->
                        <td>
                          <input type="text" v-model="p.qty_done" class="form-control" :disabled="inventory.lock"/>
                          <!-- {{ p.qty_done }} -->
                        </td>
                        <td>
                          <select v-model="p.uom_id" class="form-control" @input="setUom(index, p.uom_id, $event)" :disabled="inventory.lock">
                            <option v-for="(u, idx) in p.uomList" :key="idx" :value="u.id">{{ u.name }}</option>
                          </select>
                        </td>
                        <td>
                          <input type="text" v-model="p.cost" class="form-control" v-money="money" :disabled="inventory.lock"/>
                          <!-- {{ p.cost }} -->
                        </td>
                        <td>{{ p.total_cost | currency }}</td>
                        <td><input type="text" v-model="p.serial_number" class="form-control" :disabled="p.canBarcode"/></td>
                        <td><input type="text" v-model="p.sec_serial_number" class="form-control" :disabled="p.canBarcode"/></td>
                        <td>
                          <v-select class="vsc-custom" :options="vendorSelect" :reduce="vendor => vendor.meta.code" label="vendor" v-model="p.vendor_no" :disabled="inventory.lock"/>
                        </td>
                        <td>
                          <button type="button" class="btn btn-sm btn-soft-outline-danger" @click="remove(index)" v-if="inventory.lock === false">
                            <i class="fa fa-trash"></i>
                          </button>
                          <button type="button" class="btn btn-sm btn-soft-primary" @click="setAccountIndexBegin(index)" v-if="inventory.lock === false"><i class="fa fa-refresh"></i></button>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span @click="addLine" class="link-secondary" v-if="inventory.lock === false">Add Line</span>
                        </td>
                        <td><h5>Total: {{ totalDetailCount }}</h5></td>
                        <td>
                          {{ totalDetailQtyDemand }}
                        </td>
                        <td></td>
                        <td>
                          {{ totalDetailAmount }}
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="row" v-else>
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table table-sm table-item table-striped">
                    <thead>
                      <th>Product No.</th>
                      <th>Product</th>
                      <th>Qty</th>
                      <th>UoM</th>
                      <th>Machine No.</th>
                      <th>Frame No.</th>
                      <th>Internal No.</th>
                      <th>Cost</th>
                      <th>#</th>
                    </thead>
                    <tbody>
                      <tr v-for="(p, index) in inventory.details" :key="p.id">
                        <td>
                          <!-- <input type="text" v-model="p.product_no" class="form-control" /> -->
                          <p class="input-group">
                            <input type="text" class="form-control" v-model="p.product_no" disabled="disabled" />
                            <span class="input-group-btn ml-1">
                              <button v-if="inventory.lock === false" data-toggle="modal" data-target="#modalGetProduct" data-backdrop="static" data-keyboard="false" type="button" class="btn btn-soft-primary btn-sm" @click="setIdDetail(index)"><i class="fa fa-search" aria-hidden="true"></i></button>
                            </span>
                          </p>
                        </td>
                        <td><input type="text" v-model="p.product" class="form-control" disabled="disabled"/></td>
                        <td><input type="text" v-model="p.qty_done" class="form-control" disabled="disabled"/></td>
                        <td>
                          <select v-model="p.uom_id" class="form-control" @input="setUom(index, p.uom_id, $event)" :disabled="inventory.lock">
                            <option v-for="u in p.uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                          </select>
                        </td>
                        <td><input type="text" v-model="p.serial_number" class="form-control" /></td>
                        <td><input type="text" v-model="p.sec_serial_number" class="form-control" /></td>
                        <td><input type="text" v-model="p.internal_no" class="form-control" /></td>
                        <td><input type="text" v-model="p.cost" class="form-control"/></td>
                        <td>
                          <button type="button" class="btn btn-sm btn-soft-outline-danger" @click="remove(index)"  v-if="inventory.lock === false">
                            <i class="fa fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td><span @click="addLine" class="link-secondary" v-if="inventory.lock === false">Add Line</span></td>
                        <td><h5>Total: {{ totalDetailCount }}</h5></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
          </div>
        </div>
      </div>
      <PurchasingProductModal :idDetail="idDetail" @selectProduct="selectProduct" :type="'regular'"/>
      <InventoryModal :setting="setting" />
      <InventoryPurchasingModal :inventory="inventory" @selectPurchasing="selectPurchasing" @getRequestEdit="getRequestEdit" @getRequestVoid="getRequestVoid" />
      <div class="row justify-content-md-center">
        <div class="col-md-6">
          <h5>Logs:</h5>
          <div class="alert alert-info" role="alert" v-for="l in inventory.logs" :key="l.id">
            <b>{{ l.user }}</b> - {{ l.log_date | dateFormat('DD/MM/YYYY HH:mm:ss') }} <span>"{{ l.description }}"</span>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapState } from 'vuex'
import { accountUrl, inventoryUrl, lockUrl, productUrl, getHeader } from '@/config'
import InventoryModal from '@/components/inventory/InventoryModal.vue'
import PurchasingProductModal from '@/components/purchasing/PurchasingProductModal.vue'
import InventoryPurchasingModal from '@/components/inventory/InventoryPurchasingModal.vue'

export default {
  name: 'InventoryForm',
  props: ['inventory', 'purchasing'],
  components: {
    Loading,
    PurchasingProductModal,
    InventoryModal,
    InventoryPurchasingModal
  },
  created () {
    // Add barcode scan listener and pass the callback function
    console.log('created')
  },
  mounted () {
    this.$barcodeScanner.init(this.onBarcodeScanned)
  },
  destroyed () {
    // Remove listener when component is destroyed
    this.$barcodeScanner.destroy()
  },
  data () {
    return {
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      searchQueryPurchasing: '',
      card1: 'col-md-12',
      card2: 'col-md-4',
      selected: [],
      selectAll: null,
      idDetail: null,
      idPDetail: null,
      product: {
        product_no: null,
        uom_id: null
      },
      setting: {
        product_no: null,
        product: null,
        uom_id: null,
        uomList: null,
        expired_date: null,
        cost: null,
        vendor_no: null
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      inventoryTypeList: state => state.inventories.inventoryTypeList,
      warehouseList: state => state.warehouses.warehouseList,
      uomList: state => state.uom.uomList,
      vendorList: state => state.vendors.vendorList,
      authUser: state => state.users.authUser,
      productListSelect: state => state.products.productListSelect,
      companyList: state => state.companies.companyList
    }),
    countRowBarangDagangan () {
      var array = this.inventory.details
      var count = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].product_type_id === 5) {
          if (parseFloat(array[i].cost) !== 0) {
            count += 1
          }
        }
      }
      return count
    },
    countRowBahanBaku () {
      var array = this.inventory.details
      var count = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].product_type_id === 1 || array[i].product_type_id === 2) {
          if (parseFloat(array[i].cost) !== 0) {
            count += 1
          }
        }
      }
      return count
    },
    countRowBarangJadi () {
      var array = this.inventory.details
      var count = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].product_type_id === 3 || array[i].product_type_id === 4) {
          if (parseFloat(array[i].cost) !== 0) {
            count += 1
          }
        }
      }
      return count
    },
    countRowBarangSetengahJadi () {
      var array = this.inventory.details
      var count = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].product_type_id === 6) {
          if (parseFloat(array[i].cost) !== 0) {
            count += 1
          }
        }
      }
      return count
    },
    totalBarangDagangan () {
      var array = this.inventory.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].product_type_id === 5) {
          const cost = array[i].cost.replace(/\./g, '')
          sum += parseFloat(array[i].qty_done) * parseFloat(cost.replace(',', '.'))
        }
      }
      return sum
    },
    totalBahanBaku () {
      var array = this.inventory.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].product_type_id === 1 || array[i].product_type_id === 2) {
          if (parseFloat(array[i].cost) !== 0) {
            sum += parseFloat(array[i].qty_done) * parseFloat(array[i].cost.toString().replace(/\./g, ''))
          }
        }
      }
      return sum
    },
    totalBarangJadi () {
      var array = this.inventory.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].product_type_id === 3 || array[i].product_type_id === 4) {
          if (parseFloat(array[i].cost) !== 0) {
            sum += parseFloat(array[i].qty_done) * parseFloat(array[i].cost.toString().replace(/\./g, ''))
          }
        }
      }
      return sum
    },
    totalBarangSetengahJadi () {
      var array = this.inventory.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].product_type_id === 6) {
          if (parseFloat(array[i].cost) !== 0) {
            sum += parseFloat(array[i].qty_done) * parseFloat(array[i].cost.toString().replace(/\./g, ''))
          }
        }
      }
      return sum
    },
    totalDetailAmount () {
      var sum = 0
      var array = this.inventory.details
      for (let i = 0; i < array.length; i++) {
        const sumArray = parseFloat(array[i].qty_done) * parseFloat(array[i].cost.toString().replace(/\./g, ''))
        sum += sumArray
      }
      return sum
    },
    totalPurchasingQty () {
      var sum = 0
      var array = this.inventory.purchasing
      for (let i = 0; i < array.length; i++) {
        var arr = array[i].details.filter(d => {
          for (const name in d) {
            if (d[name] !== null) {
              if (d[name].toString().toLowerCase().indexOf(this.searchQueryPurchasing.toLowerCase()) > -1) {
                return d
              }
            }
          }
        })
        if (arr.length > 0) {
          for (let l = 0; l < arr.length; l++) {
            sum += parseFloat(arr[l].qty)
          }
        }
      }
      return sum
    },
    totalPurchasingQtyDone () {
      var sum = 0
      var array = this.inventory.purchasing
      for (let i = 0; i < array.length; i++) {
        var arr = array[i].details.filter(d => {
          for (const name in d) {
            if (d[name] !== null) {
              if (d[name].toString().toLowerCase().indexOf(this.searchQueryPurchasing.toLowerCase()) > -1) {
                return d
              }
            }
          }
        })
        if (arr.length > 0) {
          for (let l = 0; l < arr.length; l++) {
            sum += parseFloat(arr[l].qty_done)
          }
        }
      }
      return sum
    },
    purchasingDetailList () {
      var array = this.inventory.purchasing
      var loop = []
      if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
          var arr = array[i].details
          if (arr.length > 0) {
            for (let a = 0; a < arr.length; a++) {
              var obj = {
                id: arr[a].id,
                purchasing_no: array[i].purchasing_no,
                purchasing_date: arr[a].purchasing_date,
                sp_no: array[i].sp_no,
                product_no: arr[a].product_no,
                product: arr[a].product,
                qty: arr[a].qty,
                qty_done: arr[a].qty_done,
                uom_id: arr[a].uom_id
              }
              loop.push(obj)
            }
          }
        }
      }
      return loop.filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQueryPurchasing.toLowerCase()) > -1) {
              return d
            }
          }
        }
      })
    },
    vendorData () {
      var data = this.vendorList.find(d => d.vendor_no === this.inventory.vendor_no)
      var obj = {}
      if (data) {
        obj = data
      } else {
        obj = {
          id: null,
          name: null,
          vendor_no: null,
          type_id: null,
          email: null,
          phone: null,
          mobile: null,
          vat: null,
          address: null,
          city_id: null,
          city: null,
          state_id: null,
          state: null,
          postalcode: null,
          alias: null,
          company_no: null
        }
      }
      return obj
    },
    vendorSelect () {
      var loop = []
      var array = this.vendorList
      for (let i = 0; i < array.length; i++) {
        var obj = {
          vendor: array[i].vendor_no + ' - ' + array[i].name,
          meta: {
            code: array[i].vendor_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    productselect: function () {
      var loop = []
      var array = this.productListSelect
      for (var x = 0; x < array.length; x++) {
        var obj = {
          product: array[x].product_no + ' - ' + array[x].product_name,
          meta: {
            code: array[x].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    totalDetailCount () {
      return this.inventory.details.length
    },
    totalDetailQtyDemand () {
      var sum = 0
      var array = this.inventory.details
      for (let i = 0; i < array.length; i++) {
        sum += parseInt(array[i].qty_demand)
      }
      return sum
    },
    totalDetailQtyDone () {
      var sum = 0
      var array = this.inventory.details
      for (let i = 0; i < array.length; i++) {
        sum += parseInt(array[i].qty_done)
      }
      return sum
    },
    getLogs: function () {
      return this.inventory.logs.filter(d => d.id !== null)
    },
    totalDetailRaw () {
      const array = this.inventory.details
      let sum = 0
      for (let i = 0; i < array.length; i++) {
        const cost = array[i].cost.replace(/\./g, '')
        sum += parseFloat(array[i].qty_done) * parseFloat(cost.replace(',', '.'))
      }
      return sum
    },
    purchasingDetail: function () {
      return this.purchasing.details
    }
  },
  methods: {
    async setUom (index, item, event) {
      var oldValue = item
      console.log('old value ' + oldValue)
      var newValue = event.target.value
      console.log('new value ' + newValue)
      var detail = this.inventory.details[index]
      console.log(detail)
      var detailUom = detail.uomList.find(d => d.id === newValue)
      console.log(detailUom.category)
      // var qtyDone = 0
      // if (detailUom.category === 2) {
      //   qtyDone = parseFloat(detail.qty_done) / parseFloat(detailUom.ratio)
      // } else if (detailUom.category === 1) {
      //   qtyDone = parseFloat(detail.qty_done) * parseFloat(detailUom.ratio)
      // }
      // console.log(qtyDone)
      // detail.qty_done = qtyDone
    },
    async setAccountIndexBegin (index) {
      if (this.inventory.type_id === 'begin') {
        this.$Progress.start()
        this.loader.isLoading = true
        var detail = this.inventory.details[index]
        var cost = detail.cost.replace(/\./g, '')
        var obj = {
          date: this.inventory.inventory_date,
          company: this.inventory.company_no,
          uom_id: detail.uom_id,
          qty: detail.qty_done,
          cost: parseFloat(cost.replace(',', '.')),
          product_no: detail.product_no
        }
        console.log(obj)
        console.log(accountUrl + '/set-saldo-awal')
        await axios.post(accountUrl + '/set-saldo-awal', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
            this.$Progress.finish()
            this.loader.isLoading = false
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            this.$Progress.finish()
            this.loader.isLoading = false
            throw error
          })
        await this.$swal('Success', 'Succes set account "Persediaan"', 'success')
      }
    },
    async setAccountBegin () {
      if (this.inventory.type_id === 'begin') {
        this.$Progress.start()
        this.loader.isLoading = true
        var array = this.inventory.details
        let count = 0
        for (let i = 0; i < array.length; i++) {
          var cost = array[i].cost.replace(/\./g, '')
          var obj = {
            date: this.inventory.inventory_date,
            company: this.inventory.company_no,
            uom_id: array[i].uom_id,
            qty: array[i].qty_done,
            cost: parseFloat(cost.replace(',', '.')),
            product_no: array[i].product_no
          }
          // console.log(obj)
          console.log(array[i].product_no)
          console.log(accountUrl + '/set-saldo-awal')
          await axios.post(accountUrl + '/set-saldo-awal', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response.data.data)
              count += 1
              console.log(count)
              this.$Progress.finish()
              this.loader.isLoading = false
            })
            .catch(error => {
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              this.$Progress.finish()
              this.loader.isLoading = false
              throw error
            })
        }
        await this.$swal('Success', 'Succes set account "Persediaan"' + '(' + count + ')', 'success')
      }
    },
    async setModal () {
      await this.$Progress.start()
      this.loader.isLoading = true
      var cid = null
      cid = this.inventory.company_no === 'C0001' ? cid = '01' : cid = '11'
      var body = {
        account_code: cid + '-310-001',
        saldo: this.totalDetailAmount,
        saldo_date: this.inventory.inventory_date,
        method: 'debet',
        product_no: null
      }
      console.log(body)
      await axios.post(accountUrl + '/saldo', body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Inventory', response.data.message, 'success')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async setCOGS () {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.inventory.details
      for (let i = 0; i < array.length; i++) {
        var data = {
          date: this.inventory.inventory_date,
          product_no: array[i].product_no,
          type: 'inventory',
          company_no: this.inventory.company_no
        }
        console.log(data)
        await axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log('success sync cogs')
            console.log(response.data.data)
          })
          .catch(error => {
            console.log(error.response)
          })
      }
      await this.$swal('Success', 'Success Sync COGS', 'success')
      this.$Progress.finish()
      this.loader.isLoading = false
    },
    async setCOGSAll () {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.inventory.details
      for (let i = 0; i < array.length; i++) {
        var data = {
          date: this.inventory.inventory_date,
          product_no: array[i].product_no,
          type: 'all',
          company_no: this.inventory.company_no
        }
        console.log(data)
        await axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log('success sync cogs')
            console.log(response.data.data)
          })
          .catch(error => {
            console.log(error.response)
          })
      }
      await this.$swal('Success', 'Success Sync COGS', 'success')
      this.$Progress.finish()
      this.loader.isLoading = false
    },
    selectProductToPurchase (product) {
      this.searchQueryPurchasing = product
      this.card1 = 'col-md-8'
      this.card2 = 'col-md-4'
    },
    removePurchasing (index) {
      this.inventory.purchasing.splice(index, 1)
      this.selectPurchasing(this.inventory.purchasing)
    },
    changeView () {
      if (this.card1 === 'col-md-12') {
        this.card1 = 'col-md-8'
        this.card2 = 'col-md-4'
      } else {
        this.card1 = 'col-md-12'
        this.card2 = null
      }
    },
    selectCheckDetail (index) {
      var detail = this.inventory.details[index]
      if (detail.receive_finish !== true) {
        console.log(detail.qty_demand)
        detail.qty_done = detail.qty_demand
      } else {
        detail.qty_done = 0
      }
    },
    select () {
      this.selected = []
      this.currentPage = 1
      var array = this.inventory.details
      if (!this.selectAll) {
        for (const i in array) {
          array[i].receive_finish = true
          array[i].qty_done = array[i].qty_demand
        }
      } else {
        for (const i in array) {
          array[i].receive_finish = false
          array[i].qty_done = 0
        }
      }
    },
    async setProduct (index) {
      var detail = this.inventory.details[index]
      var product = this.productListSelect.find(d => d.product_no === detail.product_no)
      console.log('Product: ')
      console.log(product)
      detail.product_no = product.product_no
      detail.product = product.product_name
      detail.canBarcode = product.canBarcode
      detail.uom_id = product.uom_id
      var body = {
        product_no: detail.product_no
      }
      await axios.post(productUrl + '/uom/list', body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.data)
          detail.uomList = response.data.data
          this.inventory.details[index].uom_id = product.uom_id
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async getRequestEdit (value) {
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.inventory.inventory_no,
        lock_note: value,
        type: 'inventory'
      }
      await axios.post(lockUrl, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Success',
            'Inventory has been request to unlock',
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
        })
    },
    getRequestVoid (value) {
      console.log(value)
    },
    async removeAllDetail () {
      var array = this.inventory.details
      for (let i = 0; i < array.length; i++) {
        if (typeof array[i].id === 'undefined') {
        } else {
          await axios.delete(inventoryUrl + '/detail/' + array[i].id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response)
            })
            .catch(error => {
              console.log(error.response.data)
            })
        }
      }
      this.inventory.details = []
    },
    selectPurchasing (value) {
      this.inventory.purchasing = value
      this.removeAllDetail()
      var warehouse = {}
      var company = null
      for (let a = 0; a < value.length; a++) {
        warehouse = this.warehouseList.find(d => d.company_no === value[a].company_no)
        company = value[a].company_no
        var array = value[a].details
        for (let i = 0; i < array.length; i++) {
          var inv = this.inventory.details.find(d => d.product_no === array[i].product_no)
          if (inv) {
            console.log('PRODUCT EXIST: ' + array[i].product_no)
            inv.qty_demand = parseInt(inv.qty_demand) + parseInt(array[i].qty)
          } else {
            var qtyDone = array[i].qty_done === '' || array[i].qty_done === null ? 0 : parseInt(array[i].qty_done)
            var obj = {
              inventory_no: this.inventory.inventory_no,
              qty_demand: parseInt(array[i].qty) - qtyDone,
              qty_done: '0',
              serial_number: null,
              product_no: array[i].product_no,
              product_sku: null,
              warehouse_no: this.inventory.warehouse_no,
              uom_id: array[i].uom_id,
              inventory_date: this.inventory.inventory_date,
              branch_no: this.inventory.branch_no,
              company_no: this.inventory.company_no,
              expired_date: null,
              sec_serial_number: null,
              vendor_no: value.vendor_no,
              canBarcode: array[i].canBarcode,
              receive_finish: false,
              cost: null,
              state: 'create'
            }
            this.inventory.details.push(obj)
          }
        }
      }
      this.inventory.warehouse_no = warehouse ? warehouse.warehouse_no : null
      this.inventory.company_no = company
    },
    getPurchasingId (index) {
      var purch = this.inventory.purchasing[index]
      var payload = {
        purchasing: purch.purchasing_no
      }
      console.log(payload)
      this.$store.dispatch('getPurchasingID', payload)
    },
    getPurchasing () {
      var payload = {
        status: 'order',
        vendor: this.inventory.vendor_no
      }
      this.$store.dispatch('getPurchasingList', payload)
    },
    setSetting: function () {
      this.$store.dispatch('getProductList')
    },
    onBarcodeScanned: function (barcode) {
      var check = this.inventory.details.find(d => d.serial_number === barcode)
      if (typeof check === 'undefined') {
        var obj = {
          inventory_no: null,
          serial_number: barcode,
          sec_serial_number: null,
          product_no: this.setting.product_no,
          product_sku: null,
          product: this.setting.product,
          inventory_date: null,
          canBarcode: false,
          warehouse_no: null,
          branch_no: null,
          company_no: null,
          uom_id: this.setting.uom_id,
          uomList: this.setting.uomList,
          qty_demand: 1,
          qty_done: 1,
          expired_date: this.setting.expired_date,
          cost: this.setting.cost,
          vendor_no: this.setting.vendor_no,
          state: 'create'
        }
        this.inventory.details.push(obj)
        // console.log(window.scrollTop)
        var position = window.pageYOffset || document.documentElement.scrollTop
        var newposition = parseInt(position) + 50
        window.scrollTo(0, newposition)
      }
    },
    remove: function (index) {
      var detail = this.inventory.details[index]
      console.log(detail)
      if (detail.state === 'create') {
        this.inventory.details.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(inventoryUrl + '/detail/' + detail.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                this.inventory.details.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      }
    },
    setIdDetail: function (id) {
      this.idDetail = id
    },
    selectProduct: function (data) {
      var snu = false
      if (data.canBarcode === true) {
        snu = false
      } else {
        snu = true
      }
      var inv = this.inventory.details[this.idDetail]
      inv.inventory_no = null
      inv.qty_demand = 1
      inv.qty_done = 1
      inv.serial_number = null
      inv.product_no = data.product_no
      inv.product_sku = data.product_sku
      inv.canBarcode = snu
      inv.product = data.product_name
      inv.warehouse_no = null
      inv.uom_id = data.uom_id
      inv.expired_date = data.expired_date
      inv.uomList = data.uomList
      inv.branch_no = data.branch_no
      inv.cost = data.cost
      inv.vendor_no = this.setting.vendor_no
    },
    addLine: function () {
      var obj = {
        inventory_no: null,
        qty_demand: 0,
        qty_done: 0,
        serial_number: null,
        product_no: null,
        product_sku: null,
        warehouse_no: null,
        uom_id: null,
        inventory_date: null,
        branch_no: null,
        company_no: this.inventory.company_no,
        expired_date: null,
        sec_serial_number: null,
        vendor_no: null,
        canBarcode: false,
        cost: '0',
        total_cost: '0',
        receive_finish: true,
        uomList: [{
          id: null,
          name: null,
          ratio: '0',
          category: null
        }],
        state: 'create'
      }
      this.inventory.details.push(obj)
    },
    async approveInventory () {
      await axios.get(inventoryUrl + '/approve/' + this.inventory.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.$emit('backSaveClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
      await this.setCOGS()
    },
    saveInventory: function () {
      this.$Progress.start()
      this.loader.isLoading = true
      var inv = this.inventory
      var detail = []
      var array = this.inventory.details
      for (let i = 0; i < array.length; i++) {
        var rfinish = parseInt(array[i].qty_demand) === parseInt(array[i].qty_done) ? 'true' : 'false'
        const cost = array[i].cost.replace(/\./g, '')
        var obj = {
          id: array[i].id,
          inventory_no: array[i].inventory_no,
          serial_number: array[i].serial_number,
          sec_serial_number: array[i].sec_serial_number,
          product_no: array[i].product_no,
          product_sku: array[i].product_sku,
          warehouse_no: array[i].warehouse_no,
          uom_id: array[i].uom_id,
          qty_demand: array[i].qty_demand,
          qty_done: array[i].qty_done,
          inventory_date: array[i].inventory_date,
          branch_no: array[i].branch_no,
          expired_date: array[i].expired_date,
          internal_no: array[i].internal_no,
          cost: parseFloat(cost.replace(',', '.')),
          vendor_no: array[i].vendor_no,
          receive_finish: rfinish
        }
        detail.push(obj)
      }
      var data = {
        id: inv.id,
        inventory_no: inv.inventory_no,
        type_id: inv.type_id,
        inventory_date: inv.inventory_date,
        notes: inv.notes,
        purchasing_no: inv.purchasing_no,
        warehouse_no: inv.warehouse_no,
        company_no: inv.company_no,
        branch_no: inv.branch_no,
        ext_no: inv.ext_no,
        status: inv.status,
        user_id: inv.user_id,
        user_approve: inv.user_approve,
        lock: inv.lock,
        ext_no2: inv.ext_no2,
        vendor_no: inv.vendor_no,
        details: detail,
        purchasing: inv.purchasing
      }
      axios.post(inventoryUrl, data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$emit('backSaveClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    saveDraft: function () {
      axios.post(inventoryUrl, this.inventory, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    updateInventory: function () {
      this.$Progress.start()
      this.loader.isLoading = true
      var inv = this.inventory
      var detail = []
      var array = this.inventory.details
      for (let i = 0; i < array.length; i++) {
        var rfinish = parseInt(array[i].qty_demand) === parseInt(array[i].qty_done) ? 'true' : 'false'
        var obj = {
          id: array[i].id,
          inventory_no: array[i].inventory_no,
          serial_number: array[i].serial_number,
          sec_serial_number: array[i].sec_serial_number,
          product_no: array[i].product_no,
          product_sku: array[i].product_sku,
          warehouse_no: array[i].warehouse_no,
          uom_id: array[i].uom_id,
          qty_demand: array[i].qty_demand,
          qty_done: array[i].qty_done,
          inventory_date: array[i].inventory_date,
          branch_no: array[i].branch_no,
          expired_date: array[i].expired_date,
          internal_no: array[i].internal_no,
          cost: array[i].cost,
          vendor_no: array[i].vendor_no,
          receive_finish: rfinish
        }
        detail.push(obj)
      }
      var data = {
        id: inv.id,
        inventory_no: inv.inventory_no,
        type_id: inv.type_id,
        inventory_date: inv.inventory_date,
        notes: inv.notes,
        purchasing_no: inv.purchasing_no,
        warehouse_no: inv.warehouse_no,
        company_no: inv.company_no,
        branch_no: inv.branch_no,
        ext_no: inv.ext_no,
        status: inv.status,
        user_id: inv.user_id,
        user_approve: inv.user_approve,
        lock: inv.lock,
        ext_no2: inv.ext_no2,
        vendor_no: inv.vendor_no,
        details: detail,
        purchasing: inv.purchasing
      }
      axios.put(inventoryUrl + '/' + this.inventory.id, data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$emit('backSaveClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    updateDraftInventory: function () {
      axios.put(inventoryUrl + '/' + this.inventory.id, this.inventory, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            '<pre>' + error.response.data.message + '</pre>',
            'error'
          )
        })
    },
    addBarcode: function (id) {
      this.idPDetail = id
      var pDetail = this.purchasing.details.find(d => d.id === id)
      var uom = this.uomList.find(d => d.id === pDetail.uom_id)
      var newUom = this.uomList.find(d => {
        if (d.type_id === uom.type_id && d.category_id === 3) {
          return d
        }
      })
      var ind = this.inventory.details.find(d => d.id === null)
      /* eslint-disable */
      var newID = Math.floor(Math.random() * (9999999999 - 666666666666) + 666666666666)
      if (ind) {
        ind.id = newID,
        ind.product_no = pDetail.product_no
        ind.product = pDetail.product
        ind.uom_id = newUom.id
        ind.qty_done = 1
      } else {
        if (pDetail.canBarcode === false) {
          const inv = this.inventory.details.filter(p => p.product_no === pDetail.product_no)
          if (inv.length < 1){
            var obj = {
              id: newID,
              inventory_no: null,
              qty_demand: null,
              qty_done: 1,
              serial_number: null,
              product_no: pDetail.product_no,
              product: pDetail.product,
              canBarcode: pDetail.canBarcode,
              warehouse_no: null,
              uom_id: newUom.id
            }
            // this.inventory.detail.push(obj)
          }
        } else {
          var obj = {
            id: newID,
            inventory_no: null,
            qty_demand: null,
            qty_done: 1,
            serial_number: null,
            product_no: pDetail.product_no,
            product: pDetail.product,
            canBarcode: pDetail.canBarcode,
            warehouse_no: null,
            uom_id: newUom.id
          }
          // this.inventory.detail.push(obj)
        }
      }
      this.product = {
        product_no: pDetail.product_no,
        uom_id: newUom.id
      }
    },
    backParent: function () {
      this.$emit('backClicked')
    },
    saveBarcode: function (value) {
      var pd = this.purchasing.details.find(d => d.id === value.idPDetail)
      pd.qty_done = value.qty_done
      console.log(value)
      console.log(pd)
    }
  }
}
</script>

<style>
.flex {
  display: flex;
  flex-direction: row;
}
</style>